export const COMMON_CONSTANTS = {
  ACTION_LINKS_LOGIN: 'https://actions.rsc.org.uk/log-in-asp',
  ACTION_LINKS_SIGNUP: 'https://actions.rsc.org.uk/asp-sign-up',
};
